import type { ReactNode } from 'react';

import classNames from 'classnames';

import styles from './MultiButtonList.module.css';

export interface MultiButtonListProps {
  children: ReactNode;
  className?: string;
}

export function MultiButtonList({
  children,
  className,
  ...props
}: MultiButtonListProps) {
  return (
    <div className={classNames(styles.container, className)} {...props}>
      {children}
    </div>
  );
}
